export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const principles: Principle[] = [
  {
    icon: "ri-filter-3-line",
    title: "先核对，再发布",
    desc: "每条内容上线前都会做一次基本核对，来源不明的信息宁可晚一点，也不抢那几分钟。",
  },
  {
    icon: "ri-scales-3-line",
    title: "事实与观点分开",
    desc: "正文里明确区分「已经发生的」和「大家正在讨论的」，不让推测混进事实里。",
  },
  {
    icon: "ri-archive-2-line",
    title: "有迹可循",
    desc: "所有更新都进归档，话题的每一次变化都能顺着时间线找回来，不做无痕修改。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "林一澄",
    role: "老读者 · 关注两年",
    text: "最喜欢的是归档功能。有时候隔了一周才回来，直接按日期翻一遍就把落下的补上了，不用到处找。",
  },
  {
    name: "周钰",
    role: "社区活跃用户",
    text: "清单整理得很清楚，一个话题从头到尾的变化都摆在一起，比我到处刷碎片信息省事太多。",
  },
  {
    name: "陈叙",
    role: "内容从业者",
    text: "作为同行，我很认可他们「事实和观点分开」的做法。行业观察那部分写得克制，信息密度也够。",
  },
  {
    name: "苏牧云",
    role: "新用户",
    text: "界面干净，没有乱七八糟的弹窗，搜一下关键词就能定位到想看的内容，体验很舒服。",
  },
];